<template>
  <div id="app">
    <div
      id="ReminderBox"
      class="modal fade"
      tabindex="-1"
      role="dialog"
      aria-labelledby="ReminderBox"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <h5 id="lbl_ReminderTitle" class="modal-title">
              {{ $t("Reminder") }}
            </h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div id="lbl_ReminderContent" class="modal-body">
            <div class="form-row">
              <div class="form-group col">
                {{ errormessage }}
              </div>
            </div>

            <div class="form-row">
              <button
                class="btn btn-primary col-md-8"
                @click="onReminderCancel()"
                style="margin: auto"
              >
                {{ $t("Back") }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <canvas id="load" ref="load"></canvas>
    <div class="main-wrapper container">
      <Navbar iconAction="0" :changeurl="changeurl()"></Navbar>
      <nav
        class="navbar navbar-secondary"
        style="background-color: initial; box-shadow: 0 0px 0px rgb(0 0 0 / 0%)"
      >
        <div class="container">
          <h3>{{ $t("Welcome to KLUB 11") }}</h3>
        </div>
      </nav>

      <!-- Main Content -->
      <div class="main-content">
        <section class="section">
          <div class="section-body">
            <div class="card col-md-6" style="margin: auto">
              <div class="card-header">
                <h4>{{ desc }}</h4>
              </div>
              <div class="card-body">
                <div class="form-row">
                  <div class="form-group col-md-12">
                    <input
                      type="text"
                      name="name"
                      class="form-control"
                      id="email"
                      ref="email"
                      v-model="email"
                      :placeholder="$t('Enter your email')"
                      @input="emailcheck()"
                      @keydown="onkeyDownHandler"
                    />
                    <!-- <span
                      ref="emailerror"
                      id="emailerror"
                      style="color: red; font-size: 10px"
                      v-if="eerror"
                      >{{ $t("The email is not registered") }},
                      {{ $t("please click") }}
                      <a href="./#/">{{ $t("here") }}</a>
                      {{ $t("to register") }}{{$t('.')}}</span
                    > -->
                  </div>
                </div>
                <p style="text-align: center">
                  <a :href="this.continueWithPhoneUrl" @click="changeurl()">{{
                    $t("Continue with mobile number")
                  }}</a>
                </p>

                <div id="mcaptcha__widget-container"></div>
                <button
                  class="btn btn-primary col-md-12"
                  id="sumbit"
                  ref="sumbit"
                  @click="sumbit()"
                  :disabled="disabled"
                >
                  <span
                    class="spinner-border spinner-border-sm"
                    id="spin"
                    ref="spin"
                    role="status"
                    aria-hidden="true"
                    v-if="spinner"
                  ></span>
                  <span id="loading" ref="loading">{{ $t("Continue") }}</span>
                </button>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  </div>
</template>

<style>
canvas {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 0;
  box-sizing: border-box;
  margin: 0;
  width: 100%;
  height: 100%;
}
</style>


        <script>
import { mapActions, mapGetters } from "vuex";
import config from "@/config";
import helper from "@/vueHelper";
import Navbar from "@/components/Navbar.vue";
// import VueRecaptcha from 'vue-recaptcha';
import * as mCaptcha from '@mcaptcha/vanilla-glue';
export default {
  components: { Navbar },
  data() {
    return {
      errormessage: "",
      desc: "",
      eerror: false,
      spinner: false,
      disabled: true,
      email: null,
      k11vipcode: null,
      callbackurl: null,
      kdpmembernumber: null,
      hostname: false,
      token: "",
      continueWithPhoneUrl: "./#/",
      McaptchaSitekey:"",
      McaptchaURL:"",
    };
  },
  created() {
    this.hostname = window.location.hostname.indexOf("k11") > -1;
    this.desc = this.$t("Please Enter your email to continue");
    this.callbackurl = window.sessionStorage.getItem("callbackurl");
    this.actionSetForceBlock(false);
    const url = new URL(window.location.href)
    const params = url.searchParams;
    if (params.has("country") && params.has("phone")) {
      this.continueWithPhoneUrl = `./${url.search}#/`
    }
  },
  updated() {
    this.desc = this.$t("Please Enter your email to continue");
  },
  computed: {
    ...mapGetters("grid", ["getGridById"]),
    ...mapGetters(["getIsBlock"]),
  },
  mounted() {
    this.McaptchaSitekey = 'LDwRutV1teBB2w7NBxviGsjthQQBBvgD'
    const instanceUrl = this.hostname ? `https://${window.location.hostname}` : "https://kdp-mh-uat.k11.com";
    this.McaptchaURL = `${instanceUrl}/widget/?sitekey=${this.McaptchaSitekey}`;
    mCaptcha.default({
      widgetLink: new URL(this.McaptchaURL)
    })
  },
  methods: {
    ...mapActions("grid", [
      "actionResetGrid",
      "actionSetGrid",
      "actionRequest",
    ]),
    ...mapActions("filters", ["actionFindNow", "actionFindNowById"]),
    ...mapActions(["actionSetForceBlock", "actionSetBlock"]),
    onVerify(token){
      if (token) {
        this.token = token
      }
    },
    emailcheck() {
      var email = $(this.$refs.email);
      let filter =
        /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;
      if (filter.test(email.val())) {
        this.disabled = false;
      } else {
        this.disabled = true;
      }
    },
    onkeyDownHandler(e) {
      if (e.keyCode === 13) {
        $(this.$refs.sumbit).focus();
        event.preventDefault();
        $(this.$refs.sumbit).click();
      }
    },
    onReminderCancel() {
      $("#ReminderBox").modal("hide");
    },
    changeurl() {
      window.sessionStorage.setItem("callbackurl", this.callbackurl);
    },
    sumbit() {
      // const mcaptcha__token = $('#mcaptcha__token')
      // this.token = mcaptcha__token[0]?.value
      const token = this.token;
      let vm = this;
      var email = this.email; // $(this.$refs.flagstrap).val();
      $(this.$refs.load).css("z-index", "2147483647");
      $(this.$refs.loading)[0].innerText = this.$t("Loading") + " ...";
      vm.spinner = true;

      $.ajax({
        method: "POST",
        contentType: "application/json",
        url: config.serverURI + "/migrationhub/member/search",
        data: JSON.stringify({
          type: "1",
          parameters: {
            id: {
              value: email,
            },
          },
        }),
        complete: function (jdata) {
          if (jdata.responseJSON != null) {
            if (jdata.responseJSON.success) {
              // Search only reveals whether the email belongs to an existing
              // member and its binding state; member identifiers are
              // provided by the verification endpoint after OTP verification.
              if (jdata.responseJSON.data.kdp_bind_flag) {
                vm.errormessage = vm.$t("The email was bound");
                $("#ReminderBox").modal("show");
                vm.spinner = false;
                $(vm.$refs.loading)[0].innerText = vm.$t("Continue");
                $(vm.$refs.load).css("z-index", 0);
                return;
              }
              window.sessionStorage.setItem("k11purposes", "1");
              vm.changeurl();
              window.location.href = "./#/";
              return;
            } else {
              window.sessionStorage.setItem("k11purposes", "0");

              vm.spinner = false;
              $(vm.$refs.loading)[0].innerText = vm.$t("Continue");
              $(vm.$refs.load).css("z-index", 0);
              vm.changeurl();
              window.location.href = "./#/";
            }
          } else {
            vm.errormessage = vm.$t("Network error");
            $("#ReminderBox").modal("show");
            vm.spinner = false;
            $(vm.$refs.loading)[0].innerText = vm.$t("Continue");
            $(vm.$refs.load).css("z-index", 0);
          }
        },
      });
    },
  },
};
</script>
